import { useEffect } from "react";

import JobRemoveModalWithTracking from "app/pages/sales-intelligence/modules/crm-enrichment/containers/JobRemoveModalWithTracking";
import useJobRemoveModal from "app/pages/sales-intelligence/modules/crm-enrichment/hooks/useJobRemoveModal";
import type { CrmEnrichmentJob } from "app/pages/sales-intelligence/modules/crm-enrichment/types/types";

import useHsEnrichmentJobRemoveMutation from "../../mutations/useHsEnrichmentJobRemoveMutation";

const CrmEnrichmentJobRemoveModalContainer = ({
    job,
    onSuccess,
    onClose,
}: {
    job: CrmEnrichmentJob;
    onSuccess?: VoidFunction;
    onClose?: VoidFunction;
}) => {
    const { isOpen, closeModal } = useJobRemoveModal();

    const {
        mutate: mutateRemove,
        isPending: isLoadingRemove,
        isSuccess: isSuccessRemove,
    } = useHsEnrichmentJobRemoveMutation();

    const handleCloseModal = () => {
        closeModal();
        onClose?.();
    };

    const handleRemoveJob = () => {
        mutateRemove(job);
    };

    useEffect(() => {
        if (isSuccessRemove) {
            handleCloseModal();
            onSuccess?.();
        }
    }, [isSuccessRemove, onSuccess]);

    return (
        <JobRemoveModalWithTracking
            job={job}
            crmProvider="hubspot"
            isOpened={isOpen}
            isSubmitLoading={isLoadingRemove}
            onRemoveJob={handleRemoveJob}
            onClose={handleCloseModal}
        />
    );
};

export default CrmEnrichmentJobRemoveModalContainer;
